// import numeral from 'numeral';

// // ----------------------------------------------------------------------

// export function fNumber(number) {
//   return numeral(number).format();
// }

// export function fCurrency(number) {
//   const format = number ? numeral(number).format('$0,0.00') : '';

//   return result(format, '.00');
// }

// export function fPercent(number) {
//   const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

//   return result(format, '.0');
// }

// export function fShortenNumber(number) {
//   const format = number ? numeral(number).format('0.00a') : '';

//   return result(format, '.00');
// }

// export function fData(number) {
//   const format = number ? numeral(number).format('0.0 b') : '';

//   return result(format, '.0');
// }

// function result(format, key = '.00') {
//   const isInteger = format.includes(key);

//   return isInteger ? format.replace(key, '') : format;
// }

import numeral from "numeral";

let activeDecimalPoints = 2;

export function setNumberFormatContext(settings) {
  const value = Number(settings?.decimalPoints);
  activeDecimalPoints = Number.isInteger(value) && value >= 1 && value <= 10 ? value : 2;
}

export function getDecimalPoints() {
  return activeDecimalPoints;
}

export function formatDecimal(value, options = {}) {
  const number = Number(value ?? 0);
  const decimals = options.decimals ?? activeDecimalPoints;
  return (Number.isFinite(number) ? number : 0).toLocaleString(undefined, {
    minimumFractionDigits: options.trimZeros ? 0 : decimals,
    maximumFractionDigits: decimals,
  });
}

// ----------------------------------------------------------------------

// export function fNumber(number) {
//   return numeral(number).format();
// }


export function fNumber(number, decimals = activeDecimalPoints) {
  if (Number.isInteger(number)) {
    return numeral(number).format();
  } else {
    return numeral(number).format(`0,0.${'0'.repeat(decimals)}`);
  }
}

export function fNumberForTwoDecimals(number) {
  return formatDecimal(number);
}

export function fCurrency(number) {
  const format = number ? numeral(number).format("$0,0.00") : "";
  return result(format, ".00");
}

export function fCurrencyPKR(number) {
  const format = number ? numeral(number).format("Rs. 0,0.00") : "";
  return result(format, ".00");
}

export function fPercent(number) {
  const format = number ? numeral(Number(number) / 100).format("0.0%") : "";
  return result(format, ".0");
}

export function fShortenNumber(number) {
  const format = number ? numeral(number).format("0.00a") : "";
  return result(format, ".00");
}

export function fData(number) {
  const format = number ? numeral(number).format("0.0 b") : "";
  return result(format, ".0");
}

function result(format, key = ".00") {
  const isInteger = format.includes(key);
  return isInteger ? format.replace(key, "") : format;
}

export function fRound(number, decimals = 2) {  
  if (number == null || number === '') return null;
  if (typeof number === 'string') {
    number = number.replace(/,/g, '').trim();
    number = Number(number);
  }
  if (typeof number !== 'number' || isNaN(number)) return null;
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}


export function roundNumberToFixed(number, decimals) {
  if (isNaN(number)) {
    return 0;
  }
  if (number % 1 === 0) {
    return number;
  } else {
    const factor = Math.pow(10, decimals);
    const roundedNumber = Math.round(number * factor) / factor;
    return Number(roundedNumber.toFixed(decimals));
  }
}
